import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import useApi from "$src/core/hooks/use-api";
import { queryKey as subscriptionOffersQueryKey } from "$src/core/queries/use-subscription-offers-query";
import { queryKey as subscriptionsQueryKey } from "$src/core/queries/use-subscription-query";

const MUTATION_KEY = ["subscription-cancel"];

type Variables = {
  id: string;
};

const useSubscriptionCancelMutation = () => {
  const queryClient = useQueryClient();
  const { api } = useApi();

  const mutationFn = useCallback(
    ({ id }: Variables) => api.cancelSubscription(id),
    [api],
  );

  return useMutation({
    mutationKey: MUTATION_KEY,
    mutationFn,
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: subscriptionOffersQueryKey(),
        }),
        queryClient.invalidateQueries({
          queryKey: subscriptionsQueryKey(),
        }),
      ]);
    },
  });
};

export default useSubscriptionCancelMutation;
